export default __webpack_public_path__ + "locales/sk/FilesSettings.json?hash=32a416d492a10baa4ba2c9670e61418c";